import React, { useEffect } from 'react';

import { Link } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { COLOR_PRIMARY, COLOR_PRIMARY_DARK } from 'src/const';
import { ViewDemoButtonPropTypes } from 'src/interfaces/iproptypes';
import { useSetUserPaymentInterest } from 'src/hooks/useCustomHooks';
export interface StyleProps {
  topOffsetMobile: string;
  isLandingPage: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  overlay: {
    background: 'rgba(0, 0, 0, 0.7)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    zIndex: 5,
  },
  overlayContent: {
    position: 'absolute',
    top: ({ isLandingPage }) => (isLandingPage ? '50%' : '23%'),
    [theme.breakpoints.down(900)]: {
      top: ({ topOffsetMobile }) => topOffsetMobile, // '5%',
    },
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    textAlign: 'center',
    borderRadius: '5px',
    background: 'white',
    padding: '20px',
    color: COLOR_PRIMARY_DARK,
    fontSize: '1.2rem',
    fontWeight: 'bold',
    border: `1px solid ${COLOR_PRIMARY}`,
    cursor: 'pointer',
  },
}));

const ViewDemoButton = ({ handleClick, buttonText, topOffsetMobile }: ViewDemoButtonPropTypes) => {
  const isLandingPage = window.location.href.split('/').length <= 4;
  const props = { topOffsetMobile, isLandingPage };
  const classes = useStyles(props);

  const { triggerPaymentInterest } = useSetUserPaymentInterest();

  useEffect(() => { 
    triggerPaymentInterest();
  }, []);

  return (
    <div className={classes.overlay}>
      <div className={classes.overlayContent}>
        <Link onClick={handleClick} style={{ fontFamily: 'Roboto' }}>
          {buttonText}
        </Link>
      </div>
    </div>
  );
};

export default ViewDemoButton;
